import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../../shared/store/TextViewStore';
import TextBlockFixed from './TextBlockFixed';


const TextBlockList: React.FC = () => {
  const activeText = useTextViewStore((s) => s.activeText);
  const activeTextBlockList = useTextViewStore((s) => s.activeTextBlockList);

  if (!activeText || activeTextBlockList.length === 0) return null;

  return (
    <TextBlockContainer>
      {activeTextBlockList.map((tb) => (
        <TextBlockFixed key={tb.id} data={tb} />
      ))}
    </TextBlockContainer>
  );
};

const TextBlockContainer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 0 24px 0;
  gap: 48px;
`;

export default TextBlockList;
